import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import Header from 'common/js/header/header.js'
import DiscountTable from './DiscountTable';
import { getDiscountListSvc } from './DiscountSvc';
import DiscountSlider from './DiscountSlider';

var tokenid = localStorage.getItem("tokenid");
function DiscountCtrl() {
  const [randNo, setRandNo] = useState(0);
  const [loader, setLoader] = useState('none');
  const [discountId, setDiscountId] = useState(0)
  const [discountObj, setDiscountObj] = useState({})
  const [flgSlider, setFlgSlider] = useState(false)

  function openSlider() {
    setFlgSlider(true)
  }
  function closeSlider() {
    setFlgSlider(false)
    setDiscountObj({})
    setDiscountId(0)
    generateRandomNo()
  }
  function generateRandomNo() {
    var lRandNo = Math.floor(Math.random() * 999999);
    setRandNo(lRandNo)
  }
  function setDiscountForEdit(pDiscountId, pDiscountObj) {
    setDiscountId(pDiscountId);
    setDiscountObj(pDiscountObj)
    openSlider()
  }
  const getWingId = (wingId) => {
    // console.log('wingId = ' + wingId)
  }

  return (
    <div className='MainContainer'>
      <Header wingFromChild={getWingId} />
      <div className="col-sm-6 col-centered" style={{ pointerEvents: loader === "none" ? "auto" : "none" }}>
        <ToastContainer autoClose={3000} hideProgressBar />
        <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
          <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
        </div>
        <DiscountTable
          key={randNo}
          setDiscountForEdit={setDiscountForEdit}
          closeSlider={closeSlider}
          openSlider={openSlider}
        />

        <div style={{ display: flgSlider ? 'block' : 'none' }} className='TestSlider'>
          <DiscountSlider
            key={discountId}
            closeSlider={closeSlider}
            discountObj={discountObj}
            loader={loader}
            generateRandomNo={generateRandomNo}
          />
        </div>
      </div>
    </div>
  );
}

export default DiscountCtrl;
